import { render, staticRenderFns } from "./arrayPreview.vue?vue&type=template&id=35be9dcf&scoped=true"
import script from "./arrayPreview.vue?vue&type=script&lang=js"
export * from "./arrayPreview.vue?vue&type=script&lang=js"
import style0 from "./arrayPreview.vue?vue&type=style&index=0&id=35be9dcf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35be9dcf",
  null
  
)

export default component.exports